<template>
    <div class="flex items-center space-x-6">
      <div class="flex items-center" v-for="option in options" :key="option.id">
        <input
          type="radio"
          :name="name"
          :id="option.id"
          :value="option.id"
          v-model="value"
          class="h-5 w-5"
        />
        <label :for="option.id" class="pl-3">
          {{ option.name }}
        </label>
      </div>
    </div>
</template>

<script>
export default {
  name: "RadioForm",
  components: {},
  data() {
    return {
      value: this.modelValue
    };
  },
  props: {
    modelValue: {},
    name: {
      default: "radio1"
    },
    options: {}
  },
  watch: {
    value: function (new_value) {
      this.$emit("update:modelValue", new_value);
    }
  }
};
</script>
